/**
 * Degen frontend helpers — display formatting only.
 * Live data comes from GET /api/degen/board.
 */

export const PIPELINE_STAGES = [
  { id: 1, key: 'scan', label: 'SCAN', desc: 'NSE + BSE universe sweep' },
  { id: 2, key: 'predict', label: 'ALLOVER', desc: '21 strategies mixed vote' },
  { id: 3, key: 'validate', label: 'VALIDATE', desc: 'Momentum + Allover agree' },
  { id: 4, key: 'size', label: 'SIZE', desc: '50 shares · paper' },
  { id: 5, key: 'fill', label: 'FILL', desc: 'NSE/BSE entry' },
  { id: 6, key: 'settle', label: 'SETTLE', desc: 'P&L lock-in' }
];

export function formatRs(n) {
  const v = Math.round(Number(n) || 0);
  return `₹${v.toLocaleString('en-IN')}`;
}

export function formatSpot(n) {
  return formatRs(n);
}

export function utcClockString(d = new Date()) {
  return d.toISOString().slice(11, 19);
}

export function pipelineStageStatus(activeStage, index) {
  if (index < activeStage) return 'done';
  if (index === activeStage) return 'active';
  return 'pending';
}

export function defaultBoard() {
  return {
    ok: false,
    mode: 'DEGEN MODE · NSE/BSE',
    pipelineLabel: '6-CYCLE PIPELINE',
    month: new Date().toLocaleString('en-US', { month: 'long' }),
    realizedPnl: 0,
    tradeCount: 0,
    winRate: 0,
    tradesPerDay: 0,
    winStreak: 0,
    nextCycleSec: 3,
    activeStage: 0,
    stageProgress: 0,
    cycleMeta: {},
    direction: 'UP',
    leverage: 70,
    binsApril: 0,
    velocity1h: 0,
    spotSymbol: 'NIFTY',
    spotPrice: 0,
    candles: [],
    pnl24: [],
    winStack: [],
    pipelineRunning: true,
    scanResults: [],
    positions: [],
    lastAction: 'Connecting to degen engine…',
    activityLog: [],
    marketOpen: false,
    cash: 500000,
    universeSize: 0,
    nseCount: 0,
    bseCount: 0
  };
}
